<template>
            <div id="learingTikuSpecialList">
              <backHeader back-addr="/tikuSpecial"></backHeader>
                <br />
                <div v-show="tikuListShow">
                  <div @click="closeTikuList()" style="width:100%;text-align:center;">X</div>
                  <div class="flex-container" >
                  
                  <div v-for="(item,index) in list">
                    <a @click="goChooseTiku(item,index)" v-if="item.answerSituation==2" class="right">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else-if="item.answerSituation==1" class="wrong">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else class="notAnswer">{{index+1}}</a>
                  </div>
                  
                  <!-- <a @click="goChooseTiku(item,index)" v-for="(item,index) in list">{{index+1}}</a> -->
                </div>
                </div>
                <div class="" style="padding-left:10px;padding-right:10px;border-bottom:1px solid #BBBBBB;" v-show="!tikuListShow">
                            <div class="">
                                <div class="" style="text-align:center;">
                                    <span style="text-align:center;">答题时间:{{timeIntervalFormatter}}</span>
                                </div>
                            </div>
                            <br />
                            <div style="display:flex;text-align:center;">
                                <div style="flex:1;text-align:left;">
                                  <mt-badge size="small" color="#888">{{showType(tiku.type)}}</mt-badge>
                                  <!-- <span class="" style="font-size:0.8rem;">{{showType(tiku.type)}}</span> -->
                                </div>
                                <div style="flex:1;">
                                    <span style="font-size:0.8rem;" @click="goTikuList">{{answerCount+1}}/{{totalCount}}</span>
                                </div>
                                <div style="flex:1;text-align:right;">
                                    <!-- <img class="mui-media-object mui-pull-left" :src="collection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                                    <span style="font-size:0.8rem;">收藏</span> -->
                                    <CollectElement v-bind:collect-data="tiku" v-bind:collect-state="tiku.collectionType" v-bind:collect-id="tiku.id" v-bind:collect-type="'tikuCollect'"></CollectElement>
                                </div>
                            </div>
                            <br />
                            <div class="">
                                <div class="">
                                    <span style="font-size:0.8rem;">{{tiku.content}}：</span>
                                </div>
                            </div>
                            <br />
                            
                            <mt-checklist v-model="answerCheckBoxArr" :options="options">
                            </mt-checklist>

                            <div class="" style="display:flex">
                              <mt-button style="flex:1" plain type="danger" @click="submitTiku()" v-show="tiku.answerAble == true">确定</mt-button>
                              <!-- <button style="flex:1" type="button" class="mui-btn mui-btn-danger mui-btn-outlined" @click="submitTiku()" v-show="tiku.answerAble == true">确定</button> -->
                            </div>

                            
                            <br />
                            <div class="" v-show="tiku.showAnswerStatus">
                                <div class="">
                                    <span v-if="tiku.answerSituation==1" style="color:red;">错误</span>
                                    <span v-if="tiku.answerSituation==2" style="color:green;">正确</span>
                                    <span style="font-size:0.8rem;">正确答案为:{{tiku.answer}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="" v-show="tiku.showAnswerStatus">
                                <div class="">
                                    <span style="font-size:0.8rem;">解析:{{tiku.tip}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="" style="display:flex">
                              <mt-button style="flex:1" plain type="danger" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</mt-button>
                              <mt-button style="flex:1" plain type="danger" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</mt-button>
                                    <!-- <button style="flex:1" type="button" class="" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</button>
                                    <button style="flex:1" type="button" class="" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</button> -->
                            </div>
                       
                       
                            
                        </div>
                <div style="height:60px;"></div>
            </div>
</template>

<script>
import axios from "axios";
import Qs from "qs";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import CollectElement from "@/components/collect";
import { Toast, MessageBox } from "mint-ui";
import backHeader from "./../components/back-header.vue";

export default {
  components: {
    CollectElement,
    backHeader
  },
  data() {
    return {
      answerCheckBoxArr: [],
      //checklist设置
      options: [],
      specialName: null,
      score: 0, //得分
      timeIntervalFormatter: "00:00:00", //00:00:00格式的显示时间戳
      timeInterval: 0, //答题时间
      tikuInfo: {
        rightNum: 0, //答对题目数
        wrongNum: 0, //答错题目数
        notAnswerNum: 0, //未答题目数
        randomId: 0 //随机答题答道哪个id的题目了
      },
      //本地缓存的答题情况
      localTikuAnswerSituation: null,
      //是否显示题目列表
      tikuListShow: false,
      //是否显示答案
      //showAnswerStatus: false,
      //答案字符串
      answerString: "",

      list: [
        {
          answerAble: true,
          answer: "A",
          four: "加载中",
          one: "加载中",
          tip: "无",
          id: 6,
          type: 1,
          two: "加载中",
          three: "加载中",
          content: "加载中"
        }
      ],
      totalCount: 3,
      answerCount: 0,
      tempTiku: "",
      //当前题目
      tiku: {
        answerAble: true,
        answer: "A",
        four: "加载中",
        one: "加载中",
        tip: "无",
        id: 6,
        type: 1,
        two: "加载中",
        three: "加载中",
        content: "加载中"
      },
      //上一道题目
      prevTiku: ""
    };
  },
  props: {},
  watch: {},
  methods: {
    //向成绩头部追加新成绩
    prepend(arr, item) {
      return [item].concat(arr);
    },
    //组成度分秒字符串
    formatSeconds(value) {
      var theTime = parseInt(value); // 秒
      var theTime1 = 0; // 分
      var theTime2 = 0; // 小时
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60);
          theTime1 = parseInt(theTime1 % 60);
        }
      }
      // var result = ""+parseInt(theTime)+"秒";
      // if(theTime1 > 0) {
      //   result = ""+parseInt(theTime1)+"分"+result;
      // }
      // if(theTime2 > 0) {
      //   result = ""+parseInt(theTime2)+"小时"+result;
      // }
      var result =
        (Array(2).join(0) + theTime2).slice(-2) +
        ":" +
        (Array(2).join(0) + theTime1).slice(-2) +
        ":" +
        (Array(2).join(0) + theTime).slice(-2);
      return result;
    },
    goChooseTiku(item, index) {
      //关闭题目列表
      this.tikuListShow = false;
      //题目等于item
      this.tiku = item;
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      //为了answerCheckBoxArr不刷新，借一手
      this.$nextTick(() => {
        this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
      });
      //获取该题目的序号
      this.answerCount = index;
      //关闭答案
      //this.showAnswerStatus = false;
      //清除选择按钮
      //this.clearCheckBox();
    },
    closeTikuList() {
      this.tikuListShow = false;
    },
    goTikuList() {
      console.log("go tiku list");
      this.tikuListShow = true;
    },

    submitTiku() {
      var count = this.answerCheckBoxArr.length;

      this.answerString = this.answerCheckBoxArr.join(",");

      if (this.tiku.type == 1 && count > 1) {
        MessageBox.alert("单选题只能选择一个答案！", "提示");
        return;
      }
      if (count == 0) {
        MessageBox.alert("至少选择一个答案！", "提示");
        return;
      }
      if (this.tiku.type == 2 && count < 2) {
        MessageBox.alert("多选题最少选择二个答案！", "提示");
        return;
      }

      this.$nextTick(() => {
        //设置已经答题问题的信息
        this.list[this.answerCount].answerCheckBoxArr = this.answerCheckBoxArr;
        this.list[this.answerCount].answerAble = false;
        this.tiku.answerAble = false;
        this.tiku.showAnswerStatus = true;
        this.list[this.answerCount].showAnswerStatus = true;

        console.log("tick list is:");
        console.log(this.list[this.answerCount]);
        console.log("tiku tiku is:");
        console.log(this.tiku);
      });

      console.log("answerString is:");
      console.log(this.answerString);
      if (this.answerString == this.tiku.answer) {
        //this.showAnswerStatus = true;

        MessageBox.alert("回答正确！", "提示");
        //将答对的信息设置一下*********
        this.list[this.answerCount].answerSituation = 2;
        // console.log("list is:");
        // console.log(this.list);
        //设置得分
        this.score++;
        return;
      } else {
        //this.showAnswerStatus = true;

        MessageBox.alert("回答错误！", "提示");
        //将答错的信息设置一下*********
        this.list[this.answerCount].answerSituation = 1;
        // console.log("list is:");
        // console.log(this.list);

        //   //将错误题目写入redis数据库
        //   var redisKey = this.$store.state.appData.userId + "-" + "tikuWrong";
        //   var redisValue = this.tiku.id;
        //   axios
        //     .post(
        //       getGoAPIPrefix() + "user/collect",
        //       Qs.stringify({
        //         key: redisKey,
        //         value: redisValue,
        //         operation: 1
        //       })
        //     )
        //     .then(res => {
        //       if (res.data.returnCode == 100) {
        //         console.log("collect success");
        //         console.log("userId is:");
        //         console.log(res.data.returnData);
        //       }
        //     })
        //     .catch(err => {
        //       mui.toast("收藏功能异常！");
        //       console.log("collect failed");
        //       console.log(err);
        //     });
        //   return;
        // }
      }

      //   console.log("answer is:");
      //   console.log(this.answerCheckBox);
    },
    showPrevTiku() {
      //this.showAnswerStatus = false;
      //this.clearCheckBox();
      if (this.answerCount > 1) {
        this.answerCount--;
        this.prevTiku = this.list[this.answerCount];
        this.tiku = this.list[this.answerCount];
        this.options = [
          {
            label: this.tiku.one,
            value: "A"
          },
          {
            label: this.tiku.two,
            value: "B"
          },
          {
            label: this.tiku.three,
            value: "C"
          },
          {
            label: this.tiku.four,
            value: "D"
          }
        ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(() => {
          this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
        });
      } else if (this.answerCount == 1) {
        this.answerCount--;
        this.tiku = this.list[0];
        this.options = [
          {
            label: this.tiku.one,
            value: "A"
          },
          {
            label: this.tiku.two,
            value: "B"
          },
          {
            label: this.tiku.three,
            value: "C"
          },
          {
            label: this.tiku.four,
            value: "D"
          }
        ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(() => {
          this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
        });
        this.prevTiku = "";
      } else {
        console.log("已经是最开始了");
      }
    },
    showNextTiku() {
      //this.showAnswerStatus = false;
      //this.clearCheckBox();
      this.randomGetTiku();
    },
    getYearMonthDay() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      console.log("year month day is:");
      console.log(
        date.getFullYear() + seperator1 + month + seperator1 + strDate
      );
      return date.getFullYear() + seperator1 + month + seperator1 + strDate;
    },
    initTime() {
      setInterval(() => {
        this.timeInterval++;
        this.timeIntervalFormatter = this.formatSeconds(this.timeInterval);
      }, 1000);
    },
    //初始化随机取出一个题目
    initRandomTiku() {
      this.tiku = this.list[0];
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      console.log("this tiku is:", this.tiku);
      this.prevTiku = "";
    },
    //取出一个题目
    randomGetTiku() {
      if (this.answerCount < this.list.length - 1) {
        this.prevTiku = this.tiku;
        this.answerCount++;
        this.tiku = this.list[this.answerCount];
        this.options = [
          {
            label: this.tiku.one,
            value: "A"
          },
          {
            label: this.tiku.two,
            value: "B"
          },
          {
            label: this.tiku.three,
            value: "C"
          },
          {
            label: this.tiku.four,
            value: "D"
          }
        ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(() => {
          this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
        });
      } else {
        console.log("已经答完题目");
      }
    },
    showType: function(cellValue) {
      if (cellValue == "1") {
        return "单选";
      } else if (cellValue == "2") {
        return "多选";
      }
    },
    initTikuData() {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "tiku/listTikuSpecialList?pageNum=1&pageRow=10000&multipleSelection=" +
            this.$store.state.mineStore.multipleSelection
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //设置相关默认值
            for (var j = 0; j < res.data.returnData.list.length; j++) {
              //默认为未答状态
              res.data.returnData.list[j].answerSituation = -1;
              //默认为全部未勾选的状态
              res.data.returnData.list[j].answerAble = true;
              res.data.returnData.list[j].answerCheckBoxArr = [];
              res.data.returnData.list[j].showAnswerStatus = false;
              //res.data.returnData.list[j].answerRight=null;
            }

            //初始化赋值题目列表，以及题目总数，还有随机抽取出第一道题目
            this.list = res.data.returnData.list;
            //题目放入缓存中
            //localStorage.setItem("tiku",this.list);
            console.log("this list is:", this.list);
            // //默认设置收藏状态
            // this.list.forEach(function(value, index, array) {
            //   array[index].collectionType = false;
            // });
            this.totalCount = this.list.length;
            //将list中的数据与缓存中的答题情况进行融合，也就是给list中每个元素加上answerSituation
            this.initLocalCacheData();
            //0621
            this.initRandomTiku();
            // //开始计算时间
            // this.initTime();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initLocalCacheData() {
      if (
        localStorage.getItem("tikuAnswerSituation") === null ||
        localStorage.getItem("tikuAnswerSituation") === undefined
      ) {
        return;
      }
      //记录答题情况 答对为2 答错为1 未答为-1
      this.localTikuAnswerSituation = JSON.parse(
        localStorage.getItem("tikuAnswerSituation")
      );
      // console.log("localTikuAnswerSituation is:");
      // console.log(this.localTikuAnswerSituation[1]);
      var localLen = this.localTikuAnswerSituation.length;
      var Len = this.list.length;
      //循环获取最新list中题目的情况
      for (var j = 0; j < Len; j++) {
        //默认为未答状态
        this.list[j].answerSituation = -1;
        //查找是否有本地答题状态的记录
        for (var i = 0; i < localLen; i++) {
          // console.log("id1 is:");
          // console.log(this.localTikuAnswerSituation[i].id);
          // console.log("id2 is:");
          // console.log(this.list[j].id);
          //如果id相等，且answerSituation不为空的情况下
          if (
            this.localTikuAnswerSituation[i].id == this.list[j].id &&
            this.localTikuAnswerSituation[i].answerSituation
          ) {
            //this.list[j].answerSituation=this.localTikuAnswerSituation[i].answerSituation;//0827 暂时是专题练习的时候初始化不让显示答题情况
            continue;
          }
        }
      }
    }
  },
  filters: {},
  computed: {},
  created() {
    this.specialName = this.$route.query.specialName;
    this.initTikuData();
  },
  mounted() {},
  beforeDestroy() {
    //记录答题情况 答对为2 答错为1 未答为-1
    this.localTikuAnswerSituation = JSON.parse(
      localStorage.getItem("tikuAnswerSituation")
    );
    var localLen = this.localTikuAnswerSituation.length;
    var Len = this.list.length;
    //循环获取最新list中题目的情况
    for (var i = 0; i < localLen; i++) {
      //查找是否有本地答题状态的记录
      for (var j = 0; j < Len; j++) {
        //如果id相等
        if (this.localTikuAnswerSituation[i].id == this.list[j].id) {
          this.localTikuAnswerSituation[i].answerSituation = this.list[
            j
          ].answerSituation;
          continue;
        }
      }
    }
    //localStorage.setItem("tikuAnswerSituation", JSON.stringify(this.localTikuAnswerSituation));//0827 练习的情况不再计算相关信息

    let scoreInfo = null;
    //初始化答题情况信息
    if (
      localStorage.getItem("tikuSpecialScore") === null ||
      localStorage.getItem("tikuSpecialScore") === undefined
    ) {
      scoreInfo = [
        {
          specialName: this.specialName,
          score: this.score,
          day: this.getYearMonthDay(),
          time: this.timeIntervalFormatter
        }
      ];
    } else {
      scoreInfo = JSON.parse(localStorage.getItem("tikuSpecialScore"));
      scoreInfo = this.prepend(scoreInfo, {
        specialName: this.specialName,
        score: this.score,
        day: this.getYearMonthDay(),
        time: this.timeIntervalFormatter
      });
    }
    localStorage.setItem("tikuSpecialScore", JSON.stringify(scoreInfo));

    let sep = "^^";
    axios
      .post(
        Addr.getGoAPIPrefix() + "user/updateScoreInfo",
        Qs.stringify({
          userId: this.$store.state.mineStore.userId,
          value:
            this.specialName +
            sep +
            this.score +
            sep +
            this.getYearMonthDay() +
            sep +
            this.timeIntervalFormatter
        })
      )
      .then(res => {
        if (res.data.returnCode == 100) {
          console.log("update scoreInfo success");
          console.log(res.data.returnData);
          //mui.toast("答题成绩上传成功！");
        }
      })
      .catch(err => {
        Toast({
          message: "答题成绩上传出现异常！",
          position: "bottom",
          duration: 800
        });
        console.log("update scoreInfo failed");
        console.log(err);
      });
  },
  destroyed() {}
};
</script>

<style scoped>
#about {
  width: 100%;
  height: 100%;
}

#about-img {
  width: 100%;
}

p {
  margin-left: 15px;
  margin-right: 15px;
}


.flex-container {
  /* display: -webkit-box;
  display: -webkit-flex; */
  display: flex;
  flex-wrap: wrap;
  /* -webkit-flex-flow: row wrap; */
  /* justify-content: space-between; */
  /* text-align: center; */
  /* height: 700px; */
}

.flex-container div {
  flex: 1;
  margin: 3px;
  width: 40px;
  height: 40px;
  display: inline-block;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 25px;
  background-clip: padding-box;
  min-width: 12%;
  max-width: 12%;
  vertical-align: center;
  line-height: 40px;
}

.wrong {
  color: red;
}

.right {
  color: green;
}

.notAnswer {
  color: gray;
}
</style>


// WEBPACK FOOTER //
// src/module-tiku/tikuSpecialList.vue